import { createFileRoute } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CatalogTable } from "@/components/admin/catalog-table";

export const Route = createFileRoute("/_authenticated/admin/catalogs")({
  component: CatalogsPage,
});

function CatalogsPage() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold text-text-primary">Catalogs</h2>
        <p className="text-sm text-muted-foreground mt-0.5">Manage tasks, hazards, controls, and PPE catalog items.</p>
      </div>
      <Tabs defaultValue="tasks">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="tasks">Tasks</TabsTrigger>
          <TabsTrigger value="hazards">Hazards</TabsTrigger>
          <TabsTrigger value="controls">Controls</TabsTrigger>
          <TabsTrigger value="ppe">PPE</TabsTrigger>
        </TabsList>

        <TabsContent value="tasks">
          <CatalogTable type="tasks" />
        </TabsContent>

        <TabsContent value="hazards">
          <CatalogTable type="hazards" />
        </TabsContent>

        <TabsContent value="controls">
          <CatalogTable type="controls" />
        </TabsContent>

        <TabsContent value="ppe">
          <CatalogTable type="ppe" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
